import allaboutcrypto from "../../assets/images/allaboutcrypto.png";
import sortingvisualizer from "../../assets/images/sortingvisualizer.png";
import librarymanager from "../../assets/images/librarymanager.png";
import spacetagram from "../../assets/images/spacetagram.png";
import tasklist from "../../assets/images/tasklist.png";
import thoughtwall from "../../assets/images/thoughtwall.png";

const projectsList = [
  {
    src: allaboutcrypto,
    title: "All about crypto",
    description:
      "A web-app which displays top 100 crypto currency and related news.",
    liveLink: "https://all-about-crypto.netlify.app/",
    sourceLink: "https://github.com/aniketnegii/AllAboutCrypto",
  },
  {
    src: thoughtwall,
    title: "Thought Wall",
    description:
      "A web-app where you can share your ideas and thoughts with everyone.",
    liveLink: "https://thought-wall.netlify.app/",
    sourceLink: "https://github.com/aniketnegii/thought-wall",
  },
  {
    src: sortingvisualizer,
    title: "Sorting Visualizer",
    description:
      "A place to visualize the sorting algorithms and compare how they work w.r.t each other.",
    liveLink: "https://aniketnegii.github.io/sorting-visualizer/",
    sourceLink: "https://github.com/aniketnegii/sorting-visualizer",
  },
  {
    src: spacetagram,
    title: "Spacetagram",
    description: "A web-app which displays APOD using nasa API.",
    liveLink: "https://nasaapod-shopify.netlify.app/",
    sourceLink: "https://github.com/aniketnegii/spacetagram",
  },
  {
    src: librarymanager,
    title: "Books Manager",
    description: "A place to keep track of all your books.",
    liveLink: "https://aniketnegii.github.io/library-books/",
    sourceLink: "https://github.com/aniketnegii/library-books",
  },
  {
    src: tasklist,
    title: "Todo/Task App",
    description: "Keep track of all your daily activities",
    liveLink: "https://aniketnegii.github.io/js-tasklist/",
    sourceLink: "https://github.com/aniketnegii/js-tasklist",
  },
];

export default projectsList;
